<script setup>
import {computed, ref, watch} from 'vue'
import Button from '@/common/Button.vue'
import api from '@/services/api'
import {useAccessGroupsStore} from "@/stores/accessGroups"
import {useCategoriesStore} from "@/stores/categories"
import {useAppStore} from "@/stores/appStore"

const props = defineProps({
    item: Object
})

const appStore = useAppStore()
const accessGroupsStore = useAccessGroupsStore()
const categoriesStore = useCategoriesStore()

const categoryIds = ref([])

const email = computed(() => {
    // username is deprecated
    return props.item?.username || props.item?.email
})

const show = computed(() => {
    if (categoryIds.value?.length) {
        return (accessGroupsStore.items || [])
            .map(o => o.id)
            .some(item => categoryIds.value.includes(item))
    }
    return false
})

watch([email, () => props.item?.id], async () => {
    if (email.value?.trim().length > 0) {
        const o = await categoriesStore.getTableColumnData({
            tableName: 'm_registrants_registrants',
            columnName: 'contactGroup'
        })

        if (o) {
            categoryIds.value = o.filter(obj => obj.itemId === props.item.id).map(obj => obj.catId)
            return
        }
    }
    categoryIds.value = []
}, {immediate: true})

const onClick = async () => {
    const url = 'api/customer/get-auto-login-key?customerId=' + props.item.id
    const o = await api.get(url)

    if (o.data?.key) {
        const redirectUrl = appStore.websiteEndpoint + '/controller/Customers/autoLogin/' + o.data.key
        window.open(redirectUrl)
    }
}
</script>

<template>
    <Button v-if="show" @click="onClick" class="btn-light btn-sm border">Login</Button>
</template>